"use strict";import e from"./src/theme-lightest.css.js";import{Theme as t}from"./src/Theme.js";import"./core.js";t.registerThemeFragment("lightest","color",e);
//# sourceMappingURL=theme-lightest.js.map
